module.exports = __webpack_public_path__ + "img/complaintLogo.208a0fb9.png";